import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PaletteIcon as PaddleIcon, ShoppingBag, Calendar, Users, Home, Mail, LogOut, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from '../lib/firebase';
import AuthModal from './AuthModal';

function Navbar() {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'register'>('login');

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <PaddleIcon className="h-8 w-8 text-blue-600" />
              <span className="text-xl font-bold text-gray-900">Soavina Padel</span>
            </Link>
          </div>
          
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
              <Home className="h-5 w-5" />
              <span>Accueil</span>
            </Link>

            <Link to="/booking" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
              <Calendar className="h-5 w-5" />
              <span>Réservations</span>
            </Link>

            {user && (
              <Link to="/profile" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
                <User className="h-5 w-5" />
                <span>Profil</span>
              </Link>
            )}
            
            <Link to="/members" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
              <Users className="h-5 w-5" />
              <span>Membres</span>
            </Link>
            
            <Link to="/shop" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
              <ShoppingBag className="h-5 w-5" />
              <span>Boutique</span>
            </Link>

            <Link to="/contact" className="flex items-center space-x-1 px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100">
              <Mail className="h-5 w-5" />
              <span>Contact</span>
            </Link>
            
            {user ? (
              <div className="flex items-center space-x-4">
                <span className="text-gray-700">
                  {user.displayName || user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                >
                  <LogOut className="h-5 w-5" />
                  <span>Déconnexion</span>
                </button>
              </div>
            ) : (
              <div className="space-x-2">
                <button
                  onClick={() => {
                    setAuthMode('login');
                    setShowAuthModal(true);
                  }}
                  className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-md"
                >
                  Connexion
                </button>
                <button
                  onClick={() => {
                    setAuthMode('register');
                    setShowAuthModal(true);
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Inscription
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        mode={authMode}
      />
    </nav>
  );
}

export default Navbar;